import React, { useCallback, useEffect, useState } from 'react';
import MainSideBarItem from './MainSideBarItem';
import MyTeamIcon from '../../assets/icons/myTeamIcon';
import ControllerIcon from '../../assets/icons/controllerIcon';
import { makeStyles } from '@material-ui/core';
import { useHistory, useLocation } from 'react-router';
import userService from '../../services/user.service';
import { setUserId } from '../../Utils/authentication-access';
import logoTeamhub from '../../assets/img/logoTeamhub.svg';
import birdaiLogo from '../../assets/svg/birdaiLogo.svg';
import ProfileDropdown from '../../components/sideBar/UserProfile/ProfileDropdown';
import SupportMenu from '../../components/sideBar/SupportMenu';
import { HelpWhiteIcon } from '../../assets/icons/HelpWhiteIcon';
const Help_Center = 'https://www.birdai.com/support/';

const useStyles = makeStyles((theme) => ({
  mainContainer: {
    position: 'fixed',
    top: 0,
    left: 0,
    width: '100%',
    height: '100%',
    zIndex: '100',
  },
  secondContainer: {
    display: 'flex',
    height: '100%',
  },
  contentDev: {
    backgroundColor: '#EDEFF1',
    display: 'flex',
    flexDirection: 'column',
    flex: 1,
    overflow: 'auto',
    height: 'calc(100% - 5rem)',
  },
  loadingGrid: {
    height: '100%',
    width: '100%',
    display: 'grid',
    gridRowGap: '10px',
    gridTemplateRows: 'auto auto',
    alignContent: 'center',
    justifyContent: 'center',
    alignItems: 'center',
    justifyItems: 'center',
  },
  controllerSidebarMain: {
    display: 'flex',
    width: '59px',
    height: '100%',
    zIndex: '9998',
    position: 'absolute',
  },
  controllerSidebarSubContainer: {
    width: '59px',
    textAlign: 'center',
    height: '100%',
    position: 'fixed',
    // top: '52px',
    background: '#F7F7F7',
  },

  controllerLauncherSidebarSubContainer: {
    width: '59px',
    textAlign: 'center',
    height: '100%',
    position: 'fixed',
    background: 'rgba(0, 0, 0, 0.2)',
    backdropFilter: 'blur(87.9545px)',
  },

  mobileMenuFooter: {
    display: 'grid',
    gridGap: '27px',
    position: 'absolute',
    bottom: 0,
    left: '24px',
  },
  brandLogo: {
    height: '52px',
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'center',
  },
  helpIcon: {
    cursor: 'pointer',
  },
}));

const ControllerSidebar = () => {
  const classes = useStyles();
  const history = useHistory();
  const location = useLocation();
  const [iconMyTeams, setIconMyTeams] = useState(false);
  const [iconController, setIconController] = useState(false);
  const [userData, setUserData] = useState(null);
  const isLauncherScreen = window.location.href.includes('launcher');

  const defaultPagesActive = useCallback(() => {
    setIconMyTeams(false);
    setIconController(false);
  }, [setIconMyTeams, setIconController]);

  const iconMyTeamsClick = useCallback(() => {
    defaultPagesActive();
    setIconMyTeams(true);
    history.push('/controller/Wbflow');
  }, [defaultPagesActive, setIconMyTeams, history]);

  const iconControllerClick = useCallback(() => {
    defaultPagesActive();
    setIconController(true);
    history.push('/controller/launcher');
  }, [defaultPagesActive, setIconController, history]);

  const setOption = useCallback(() => {
    switch (location.pathname) {
      case '/controller/Wbflow':
        iconMyTeamsClick();
        break;
      case '/controller/launcher':
        iconControllerClick();
        break;
      default:
        break;
    }
  }, [location.pathname, iconMyTeamsClick, iconControllerClick]);

  const getUserDetails = useCallback(async () => {
    const response = await userService.getUserDetails();
    setUserData(response?.data?.user);
    setUserId(response?.data?.user.id);
    return response?.data?.user;
  }, []);

  useEffect(() => {
    setOption();
    getUserDetails();
  }, [getUserDetails, setOption]);

  const handleClick = (event) => {
    window.open(Help_Center, '_blank');
  };

  return (
    <>
      {/* /** side bar */}

      <div className={classes.controllerSidebarMain}>
        <div
          className={
            isLauncherScreen
              ? classes.controllerLauncherSidebarSubContainer
              : classes.controllerSidebarSubContainer
          }
        >
          <div className={classes.brandLogo}>
            <img src={birdaiLogo} alt="logo" />
          </div>
          <MainSideBarItem
            Icon={ControllerIcon}
            title="Room"
            active={iconController}
            onClick={iconControllerClick}
          />
          <MainSideBarItem
            Icon={MyTeamIcon}
            title="Spaces"
            active={iconMyTeams}
            onClick={iconMyTeamsClick}
          />

          <div
            style={{
              display: 'flex',
              justifyContent: 'center',
              alignItems: 'center',
              flexDirection: 'column',
              gap: '14.5px',
              position: 'fixed',
              bottom: '21px',
              left: '14px',
            }}
          >
            {isLauncherScreen ? (
              <div onClick={handleClick} className={classes.helpIcon}>
                <HelpWhiteIcon color={'white'} width={32} />
              </div>
            ) : (
              <div>
                <SupportMenu isSmall={true} />
              </div>
            )}
            <div>
              {userData && (
                <ProfileDropdown profileData={userData} callUserDetails={getUserDetails} />
              )}
            </div>
          </div>
        </div>
      </div>
    </>
  );
};

export default ControllerSidebar;
